<template>
  <MainNavbar class="style-three" />
  <PageTitle
    pageTitle="Terms & Conditions"
    mainTitle="Terms & Conditions"
    subTitle="Where Passion & Ingredients Unite On Your Plate"
  />
  <TermsConditions />
  <ReservationTable />
  <TestimonialSlider />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PageTitle from "../components/Common/PageTitle.vue";
import TermsConditions from "../components/TermsConditions/TermsConditions.vue";
import ReservationTable from "../components/Common/ReservationTable.vue";
import TestimonialSlider from "../components/Common/TestimonialSlider.vue";

export default defineComponent({
  name: "TermsConditionsPage",
  components: {
    MainNavbar,
    PageTitle,
    TermsConditions,
    ReservationTable,
    TestimonialSlider,
  },
});
</script>